const PARIS_TIME_ZONE = 'Europe/Paris'
const MINUTE_MS = 60000

export const CALLBACK_REMINDER_MAX_AGE_MS = 120 * MINUTE_MS

export const formatCallbackTime = (isoDate: string): string =>
  new Date(isoDate).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', timeZone: PARIS_TIME_ZONE })

export const minutesUntilCallback = (isoDate: string, now: number): number =>
  Math.ceil((Date.parse(isoDate) - now) / MINUTE_MS)

export const isCallbackExpired = (isoDate: string, now: number): boolean =>
  now - Date.parse(isoDate) >= CALLBACK_REMINDER_MAX_AGE_MS
